import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

/**
 * A/B 테스트 v2 결과 보관소.
 *
 * fem 은 Next 의 `getServerSideProps` 같은 페이지 단위 서버 진입점이 없으므로 흐름을 나눠 둔다.
 * 1) express 라우트 미들웨어(`server.routes.js`)가 `abTestingV2Ssr` 로 값을 정한다.
 *    PCID·지표 쿠키는 그 자리에서 `res` 로 심는다(렌더 안에서는 `res` 가 없어 불가능).
 * 2) `server.render.js` 가 그 결과를 이 모듈에 dispatch 한다.
 * 3) store 는 `__PRELOADED_STATE__` 로 직렬화되어 클라이언트가 같은 값으로 하이드레이트한다.
 *
 * 화면은 `useSelector` 로 읽기만 한다 — 분기 시점에 API 를 다시 조회하지 않는다.
 * 테스트가 여러 개일 수 있어 `{ [키]: 결과 }` 맵이며, 키는 라우트 미들웨어에서 정한다.
 */
const SET_AB_TEST_V2 = 'abTestV2/SET_AB_TEST_V2';

export const setAbTestV2 = createAction(SET_AB_TEST_V2);

/** 조회하지 않은 라우트(CSR 폴백 등)에서는 비어 있다 → 화면은 기본 안을 그린다. */
const initialState = {};

export default handleActions(
	{
		[SET_AB_TEST_V2]: (state, { payload }) =>
			produce(state, (draft) => {
				Object.keys(payload || {}).forEach((key) => {
					draft[key] = payload[key];
				});
			}),
	},
	initialState,
);
